/**
 * gtagへの値送信、debugがtrueなら送信せずにコンソールに出力
 * @param eventAction
 * @param eventParams
 * @param debug
 */
export const sendGtag = (id, debug = false) => {
    if (debug) {
        console.log(`gtag('event', '${id}')`);
    }
    else {
        gtag('event', id);
    }
};
